export const remarkHeader=[ {id: "errorDetails",header: "Error Details"}];
export const sessionUsageHeader = [
  { id: "product", header: "Product", sort: true },
  { id: "component", header: "Component", sort: true },
  { id: "sessionModel", header: "Session model", sort: true },
  { id: "usage", header: "Usage %", sort: true },
];
export const staffTimeHeaders = [
  {
    id: "country",
    header: "Country",
    width: 150,
    headerClassName: "grid-header",
    cellClassName: "grid-cell",
    sort: true,
    flex: 1,
  },
  {
    id: "product",
    header: "Product",
    width: 150,
    headerClassName: "grid-header",
    cellClassName: "grid-cell",
    sort: true,
    disableColumnMenu: true,
    flex: 1,
  },
  {
    id: "component",
    header: "Component",
    width: 150,
    headerClassName: "grid-header",
    cellClassName: "grid-cell",
    sort: true,
    flex: 1,
  },
  {
    id: "task",
    header: "Task Type",
    width: 150,
    headerClassName: "grid-header",
    cellClassName: "grid-cell",
    sort: true,
    flex: 1,
  },
  {
    id: "minutes",
    header: "Minutes",
    width: 150,
    headerClassName: "grid-header",
    cellClassName: "grid-cell",
    sort: true,
    disableColumnMenu: true,
    flex: 1,
  },
];
export const staffProductivityHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "product", header: "Product", sort: true },
  { id: "component", header: "Component", sort: true },
  { id: "wpoDeliveredPercent", header: "% WPO Delivered", sort: true },
  {
    id: "extAffiliateDelivered",
    header: "% Ext. Affiliate Delivered",
    sort: true,
  },
  { id: "staffProductivity", header: "Staff Productivity", sort: true },
];
export const staffCostDepartmentHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "product", header: "Product", sort: true },
  { id: "component", header: "Component", sort: true },
  { id: "task", header: "Task", sort: true },
  { id: "primaryServiceCenter", header: "Primary Service Center", sort: true },
  { id: "department", header: "Department", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "costMin", header: "Cost/Min", sort: true,showdecimals:true },
];
export const serviceDistributionHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "product", header: "Product", sort: true },
  { id: "productVariation", header: "Product Variation", sort: true },
];
export const serviceDistributionInvalidHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "product", header: "Product", sort: true },
  { id: "single_Session_Therapy", header: "Product Variation", sort: true },
  { id: "scheduled_inperson_sessions", header: "Product Variation", sort: true },
  { id: "scheduled_video_sessions", header: "Product Variation", sort: true },
  { id: "scheduled_phone_sessions", header: "Product Variation", sort: true },
  { id: "workLife_Core", header: "Product Variation", sort: true },
  { id: "workLife_LegalFinancial", header: "Product Variation", sort: true },
  { id: "general_Assistance_Clinical", header: "Product Variation", sort: true },
  { id: "general_Assistance_WorkLife", header: "Product Variation", sort: true },
  { id: "computerized_CBT", header: "Product Variation", sort: true },
  { id: "counseling_Match_To_Insurance", header: "Product Variation", sort: true },
  { id: "manager_Assist", header: "Product Variation", sort: true },
  { id: "participant_Website", header: "Product Variation", sort: true },
  { id: "life_Coaching", header: "Product Variation", sort: true },
  { id: "advisor_Assist", header: "Product Variation", sort: true },
  { id: "legal_Assist_30_Mins_25_Discount", header: "Product Variation", sort: true },
  { id: "legal_Assist_60_Mins_30_Discount", header: "Product Variation", sort: true },
  { id: "legal_Assist_Telephonic_Adv_Att", header: "Product Variation", sort: true },
  { id: "financial_Assist", header: "Product Variation", sort: true },
  { id: "adoption_Assistance", header: "Product Variation", sort: true },
  { id: "education", header: "Product Variation", sort: true },
  { id: "wellness_Coaching_Standard", header: "Product Variation", sort: true },
  { id: "live_Well_Wellness_Platform", header: "Product Variation", sort: true },
  { id: "outreach_Calls", header: "Product Variation", sort: true },
];
export const externalCostHeaders = [
  { id: "country", header: "Country", sort: true},
  { id: "answerModel", header: "Answer Model", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "ssT_Cost", header: "SST_Cost", sort: true,showdecimals:true  },
  { id: "f2F_Cost", header: "F2F_Cost", sort: true ,showdecimals:true },
  { id: "svC_Cost", header: "SVC_Cost", sort: true,showdecimals:true  },
  { id: "stC_Cost", header: "STC_Cost", sort: true,showdecimals:true  },
  { id: "core_Cost", header: "Core_Cost", sort: true,showdecimals:true  },
  { id: "lF_Cost", header: "LF_Cost", sort: true,showdecimals:true  },
  { id: "gA_Clinical", header: "GA Clinical", sort: true,showdecimals:true  },
  { id: "gA_WL", header: "GA WL", sort: true,showdecimals:true  },
  { id: "managementFee", header: "ManagementFee", sort: true,showdecimals:true  },
  { id: "pepM_Cost", header: "PEPM Cost", sort: true,showdecimals:true  },
  {
    id: "enhancedLegalServices",
    header: "Enhanced Legal Services",
    sort: true,
    showdecimals:true 
  },
  {
    id: "enhancedFinancialServices",
    header: "Enhanced Financial Services",
    sort: true,
    showdecimals:true 
  },
  {
    id: "wellnessCoaching",
    header: "Wellness Coaching",
    sort: true,
    showdecimals:true 
  },
];
export const overHeadCostHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "primaryServiceCenter", header: "Primary Service Center", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "staffOHCostPerMin", header: "Staff OH Cost per min", sort: true,showdecimals:true  },
  { id: "affOHCostPerHour", header: "Affiliate OH Cost per hour", sort: true,showdecimals:true  },
];
export const webCostHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "primaryServiceCenter", header: "Primary Service Center", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "webCostValue", header: "Web Cost", sort: true,showdecimals:true  },
];
export const marginTableHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "targetMargin", header: "Target Margin", sort: true,percentage:true },
  { id: "floorMargin", header: "Floor Margin", sort: true ,percentage:true},
];
export const pricingModelsHeaders = [
  { id: "productName", header: "Product", sort: true },
];

export const rrciAndTrainingHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "component", header: "Component", sort: true },
  { id: "country", header: "Country", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "ratePerHour", header: "Rate per Hour", sort: true },
]
export const additionalCounselingHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "component", header: "Component", sort: true },
  { id: "country", header: "Country", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "minimum", header: "Minimum", sort: true },
  { id: "maximum", header: "Maximum", sort: true },
  { id: "ratePerHour", header: "Rate per Hour", sort: true },
]
export const pathWayHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "country", header: "Country", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "minimum", header: "Minimum", sort: true },
  { id: "maximum", header: "Maximum", sort: true },
  { id: "ratePerHour", header: "Rate per Hour", sort: true },
]
export const gwqHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "country", header: "Country", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "pepm", header: "PEPM", sort: true },
]
export const nprwtHeaders = [
  { id: "product", header: "Product", sort: true },
  { id: "country", header: "Country", sort: true },
  { id: "currency", header: "Currency", sort: true },
  { id: "pepm", header: "PEPM", sort: true },
]
export const currencyHeaders = [
  { id: "fromCurrency", header: "From Currency", sort: true },
  { id: "toCurrency", header: "To Currency", sort: true },
  { id: "currencyRate", header: "Currency Rate", sort: true,showdecimals:true  },
]
export const enhancedLandFHeaders = [
  { id: "country", header: "Country", sort: true },
  { id: "enhancedLegal", header: "Enhanced Legal", sort: true },
  { id: "enhancedFinancial", header: "Enhanced Financial", sort: true },
]


